import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {
  TranslateService,
  I18nHelperService,
  SeoServiceService,
} from "@xref/ngx";

@Component({
    selector: "xqnr-home",
    templateUrl: "./home.component.pug",
    styleUrls: ["./home.component.scss"],
    standalone: false
})
export class HomeComponent implements OnInit {
  loaded = false;

  showGetStarted = false;

  currYear = new Date().getFullYear();

  retina = false;

  featureItems: any = {
    roleSpecific: "",
    compliant: "",
    unbiased: "",
    insightful: "",
  };

  constructor(
    private router: Router,
    private translate: TranslateService,
    private i18nHelper: I18nHelperService,
    private seoService: SeoServiceService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // Update meta tags

    console.log(this.activatedRoute);
    this.activatedRoute.data.subscribe((data) => {
      this.seoService.updateDescription(data.description);
      this.seoService.updateTitle(data.title);
    });

    this.setFeatureListItems();

    this.setRetina();

    this.i18nHelper.localeChanged$.subscribe(this.handleLocaleChanged);
  }

  setLoaded() {
    if (
      this.featureItems.role &&
      this.featureItems.compliant &&
      this.featureItems.unbiased &&
      this.featureItems.insightful
    ) {
      this.loaded = true;
    } else {
      this.loaded = false;
    }
  }

  setRetina() {
    if (window.devicePixelRatio > 1) this.retina = true;
    else this.retina = false;
  }

  handleLocaleChanged = () => {
    this.setFeatureListItems();
    // tslint:disable-next-line: semicolon
  };

  setFeatureItemSuccess(key: string, value: string) {
    this.featureItems[key] = value;
    this.setLoaded();
  }

  setFeatureListItems() {
    this.translate
      .get("home.questions.listItems.roleSpecific")
      .subscribe((val) => {
        this.setFeatureItemSuccess("role", val);
      });

    this.translate
      .get("home.questions.listItems.compliant")
      .subscribe((val) => {
        this.setFeatureItemSuccess("compliant", val);
      });

    this.translate.get("home.questions.listItems.unbiased").subscribe((val) => {
      this.setFeatureItemSuccess("unbiased", val);
    });

    this.translate
      .get("home.questions.listItems.insightful")
      .subscribe((val) => {
        this.setFeatureItemSuccess("insightful", val);
      });
  }

  launchBuilder() {
    this.router.navigate(["/get-started"]);
  }
}
